import './loading.scss'
export default function loading() {
  'ngInject'
  var directive = {
    restrict: 'AE',
    templateUrl: 'app/components/loading/loading.html',
    scope: {
      css: '@',
      classname: '@',
    },
    link: fileLink,
  }

  return directive

  function fileLink() {
    // $scope.show = false;
    // $rootScope.$on('loading', function(event, data){
    //     $scope.show = data;
    // });
  }
}
